type Handler = (e: Event) => any;
interface LoadScriptProps {
  innerText?: string;
  src?: string;
  id?: string;
  defer?: boolean;
  onLoad?: Handler;
  removeExisted?: boolean;
  [k: string]: number | string | boolean | Handler | undefined;
}

export const loadScript = ({
  src,
  onLoad,
  defer = false,
  id,
  innerText,
  removeExisted = false,
  ...props
}: LoadScriptProps) => {
  try {
    const addedScript = src
      ? document.querySelector(`[src="${src}"]`)
      : document.querySelector(`#${id}`);

    if (addedScript && removeExisted) {
      addedScript.remove();
    } else if (addedScript) {
      return;
    }

    const newScript = document.createElement('script');

    Object.entries(props).forEach(([key, value]) => {
      newScript.setAttribute(key, String(value));
    });

    if (defer) {
      newScript.defer = true;
    } else {
      newScript.async = true;
    }

    if (id) {
      newScript.id = id;
    }

    if (src) {
      newScript.src = src;
    } else if (innerText) {
      newScript.innerText = innerText;
    } else {
      throw new Error(`at least src or innerText required in IdleScriptClient`);
    }

    if (onLoad) newScript.onload = onLoad;

    if (defer) {
      document.head.append(newScript);
    } else {
      document.head.prepend(newScript);
    }
  } catch (error) {
    console.log(`loadScript error:`, error);
  }
};

export default loadScript;
